













/* Created- 04 - Apr - 2019 */
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { eParticaAction, ParticaEvent } from "../../Models/ParticaEvent";
import { FormFieldRules, IFormField } from "../../Models/Components.model";
import ParticaRowContainer from "@/Ui-Components/Common/Container/ParticaRowContainer.vue";

@Component(
	{
		name: "PageTurner",
		components: { ParticaRowContainer }
	})
export default class PageTurner extends Vue {
	@Prop() private initialPage: number;
	@Prop() private maxPage: number;
	private currentPage: number = 1;
	private config =
		{
			rules: { required: true, max_value: this.maxPage, min_value: 1, numeric: true } as FormFieldRules
		} as IFormField;

	@Watch("initialPage")
	private pageUpdate() {
		this.currentPage = this.initialPage;
	}
	private async mounted() {
		this.currentPage = this.initialPage;
	}
	private change() {
		if (this.currentPage >= this.maxPage) {
			this.currentPage = this.maxPage;
		}
		if (this.currentPage < 1) {
			this.currentPage = 1;
		}
		this.$emit("partica-event", { action: eParticaAction.PAGE_CHANGE, item: this.currentPage } as ParticaEvent);
	}
	private next() {
		if (this.currentPage >= this.maxPage) {
			return;
		}
		this.currentPage++;
		this.$emit("partica-event", { action: eParticaAction.PAGE_CHANGE, item: this.currentPage } as ParticaEvent);
	}
	private previous() {
		if (this.currentPage <= 1) {
			return;
		}
		this.currentPage--;
		this.$emit("partica-event", { action: eParticaAction.PAGE_CHANGE, item: this.currentPage } as ParticaEvent);
	}
}
